import { useMemo } from 'react';

import { GENERATION_TOOL } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { MultiPromptTemplatesStore } from 'src/store';

const useMultiPromptTemplatesState = createStateSelectorHook(MultiPromptTemplatesStore, [
  'multiPromptTemplates',
]);

export const usePreparedMultiPromptTemplates = () => {
  const { multiPromptTemplates } = useMultiPromptTemplatesState();

  return useMemo(
    () =>
      multiPromptTemplates.map((item) => ({
        ...item,
        // TODO: check if we need these
        title: item.title || item.name,
        tool: item.tool || GENERATION_TOOL.customMultiPrompt,
        generationTool: item.generationTool || GENERATION_TOOL.customMultiPrompt,
      })),
    [multiPromptTemplates]
  );
};
